import * as React from "react";
import DagenMap from "./DagenMap";

import KaartData from "./KaartData";
import { useStore } from "../../App";
import { observer } from "mobx-react";
import { styled } from "../../ui/theme";
import { FormLabel, Switch, Box, IconButton, Select } from "@chakra-ui/core";
import { useSwipeable } from "react-swipeable";
import { View } from "../../store/Store";
import Legend from "./Legend";

type Option = {
  key: View;
  name: string;
};

const OPTIONS: Option[] = [
  { key: "gemeente", name: "Per gemeente" },
  { key: "provincie", name: "Per Provincie" }
];

export default observer(function Map() {
  const store = useStore();

  const handlers = useSwipeable({
    onSwipedLeft: e => {
      store.nextView();
    },
    onSwipedRight: e => {
      store.prevView();
    }
  });

  return (
    <Container {...handlers}>
      <DagenMap
        fitBounds={[
          [3.31497114423, 50.803721015],
          [7.09205325687, 53.5104033474]
        ]}
        fitBoundOptions={{
          padding: {
            top: 60,
            bottom: 40,
            left: 10,
            right: 10
          }
        }}
      >
        <LegendContainer>
          <Legend colorScale={store.paint.colorScale} />
        </LegendContainer>
        <MapControlTop>
          <MapNav>
            <IconButton
              size="sm"
              aria-label="vorige"
              icon="chevron-left"
              isRound={true}
              onClick={() => {
                store.prevView();
              }}
            />
          </MapNav>
          <MapSel>
            <Select
              size="sm"
              borderRadius="20px"
              value={store.view}
              onChange={e => {
                store.view = e.currentTarget.value as View;
              }}
            >
              {store.viewOptions.map(op => (
                <option key={op.view} value={op.view}>
                  {op.name}
                </option>
              ))}
            </Select>
          </MapSel>
          <MapNav>
            <IconButton
              size="sm"
              aria-label="vorige"
              icon="chevron-right"
              isRound={true}
              onClick={() => {
                store.nextView();
              }}
            />
          </MapNav>
        </MapControlTop>
        <MapControlBottom>
          <Box maxWidth="300" ml="16px">
            <Select
              size="sm"
              width="auto"
              variant="unstyled"
              value={store.as100k ? "100k" : "total"}
              onChange={e => {
                let t = e.currentTarget.value;
                if (t === "100k") {
                  store.as100k = true;
                } else {
                  store.as100k = false;
                }
              }}
            >
              <option key={0} value="total">
                Totaal
              </option>
              <option key={1} value="100k">
                Per 100.000 inwoners
              </option>
            </Select>
          </Box>
          <Box maxWidth="300" mr="16px">
            <FormLabel fontWeight="bold" fontSize="xs" htmlFor="percentages">
              Toename?
            </FormLabel>
            <Switch
              id="delta"
              value={store.asIncrement ? "yes" : "no"}
              onChange={e => (store.asIncrement = e.currentTarget.checked)}
            />
          </Box>
        </MapControlBottom>
        {store.ready && <KaartData />}
      </DagenMap>
    </Container>
  );
});

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: stretch;
  overflow: hidden;
  max-width: 100%;
`;

const LegendContainer = styled.div`
  position: absolute;
  left: 8px;
  top: 48px;
`;

const MapControlTop = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  padding: 4px 8px;

  background-color: transparent;
  display: flex;
`;

const MapNav = styled.div`
  flex: 0 0 32px;
`;

const MapSel = styled.div`
  padding: 0 8px;
  flex: 1 1 auto;
`;

const MapControlBottom = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 44px;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
